// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* standard for all popups */
.ErrorMessagePopup_message__SAloL {
  width: 100%;
}

.ErrorMessagePopup_container__S3t0C {
  display: flex !important;
  flex-direction: row;
  align-items: center;
}

p {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ErrorMessagePopup/ErrorMessagePopup.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* standard for all popups */\n.message {\n  width: 100%;\n}\n\n.container {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n}\n\np {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `ErrorMessagePopup_message__SAloL`,
	"container": `ErrorMessagePopup_container__S3t0C`
};
export default ___CSS_LOADER_EXPORT___;
